export enum FilterCategory {
  STATE = 'State',
  THERAPY_OR_PSYCHIATRY = 'Therapy or psychiatry',
  INSURANCE = 'Insurance',
  SPECIALTY = 'Concerns',
  GENDER_PREFERENCE = 'Gender preference',
  TREATMENT_APPROACH = 'Treatment approach',
  TYPE_OF_SERVICE = 'Type of service',
  SESSION_FORMAT = 'In-person or online',
  AGE_GROUP_TREATED = 'Age group treated'
}
